import { render, staticRenderFns } from "./UserTab3.vue?vue&type=template&id=68ead69c"
import script from "./UserTab3.vue?vue&type=script&lang=js"
export * from "./UserTab3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports